import * as baseUtils from './baseUtils';
import * as commonUtils from './commonUtils';

const utils = {
  ...baseUtils,
  ...commonUtils,
};

export default utils;
